const data = {
  czechLanguage: "čeština",
  englishLanguage: "angličtina",
  "footer.version": "verze webové aplikace {version}",
  "footer.rights": "{year} © DHL International GmbH. Všechna práva vyhrazena.",
  "countries.loadError": "Při načítání států nastala chyba",
  "countries.label": "Stát",
  "countries.message": "Vyberte prosím stát!",
  "countries.placeholder": "Vyberte stát",
  "messages.pdfExport": "ve formátu pdf",
  "messages.xlsxExport": "ve formátu xlsx",
  "exportButton.question":
    "Nemáte vybrané žádné {entity}, přejete si exportovat všechny načtené {entity}?",
  "messages.yes": "Ano",
  "messages.no": "Ne",
  "messages.dateTimeItem": "Vyberte datum a čas",
  "messages.dateItem": "Vyberte datum",
  "messages.input.required": "Tento údaj je povinný!",
  "messages.input.email": "Zadejte prosím validní email!",
  "messages.input.variableSymbol":
    "Variabilní symbol musí obsahovat pouze čísla a mít maximální délku 10!",
  "messages.input.unCode": "UN kód musí obsahovat pouze čísla a být o délce 4!",
  "messages.input.companyId": "IČO musí mít maximální délku 18!",
  "messages.input.companyId.czech":
    "IČO musí obsahovat pouze čísla a mít maximální délku 12!",
  "messages.input.nationalId": "Rodné číslo není ve správném formátu!",
  "messages.input.companyIdOrNationalId":
    "Zadejte korektní IČO nebo rodné číslo!",
  "messages.input.licenceIso": "Zadejte prefix v korektním formátu!",
  "messages.input.licenceGs1": "Zadejte prefix v korektním formátu!",
  "messages.input.zipCode": "Zadejte PSČ v pětimístném formátu!",
  "messages.input.number": "Zadejte korektní číslo!",
  "messages.input.phoneNumber": "Zadejte korektní telefonní číslo!",
  "messages.input.range":
    "Překročeno povolené rozmezí hodnot od {min} do {max}!",
  "messages.loadError": "Načíst znovu",
  "messages.loadTable.error": "Při načítání {what} nastala chyba.",
  "messages.loadTable.noData": "žádná data",
  "messages.select.notAll": "Odznačit všechny záznamy",
  "messages.select.all": "Označit všechny záznamy",
  "messages.stateIcon.valid": "Všechny zadané hodnoty jsou v pořádku.",
  "messages.stateIcon.invalid":
    "Tento blok obsahuje chybějící nebo chybně zadané hodnoty!",
  "messages.filter.button": "Filtr",
  "messages.navbar.home": "Přechod na hlavní stránku",
  "messages.logout": "Odhlásit",
  "messages.userMenu": "Uživatelské menu",
  "messages.close": "Zavřít",
  "messages.save": "Uložit",
  "messages.unknown": "neznámý",
  "messages.filter": "Filtrovat",
  "messages.pages": "Strana {from} z {to}",
  "import.result": "Výsledek importu",
  "import.success": "Import dopadl úspěšně.",
  "import.error": "Při zpracování nastala chyba!",
  "import.saved": "Úspěšně uloženo!",
  "import.not.saved": "Při importování ceníku nastal problém - {error}!",
  "import.title": "Soubor bez názvu",
  "import.title.code": "Soubor {code}",
  "login.username.error": "Vyplňte prosím uživatelské jméno!",
  "login.username": "uživatelské jméno",
  "login.password": "heslo",
  "login.password.error": "Vyplňte prosím heslo!",
  login: "Přihlásit se",
  "messages.accessDenied": "Přístup odepřen",
  "messages.accessDenied.message":
    "K této webové aplikace nemáte přístup. Pokud si myslíte, že byste ho měl mít, kontaktujte DHL ITS.",
  "crud.create": "{what} byl{suffix} úspěšně vytvořen{suffix}.",
  "crud.createError": "Při vytváření {whatError} nastala chyba!",
  "crud.edit": "{what} byl{suffix} úspěšně upraven{suffix}.",
  "crud.editError": "Při úpravě {whatError} nastala chyba!.",
  "crud.delete": "{what} byl{suffix} úspěšně smazán{suffix}.",
  "crud.deleteError": "Při mazání {whatError} nastala chyba!",
  "session.securityLogout": "Došlo k bezpečnostnímu odhlášení!",
  "session.authorizationError": "K této operaci nemáte práva!",
  "messages.warning": "Upozornění",
  "messages.error": "Při odesílání dat nastala chyba!",
  "session.logout": "Došlo k odhlášení!",
  "session.loginError":
    "Server není dostupný, zkuste prosím přihlášení později!",
  "welcome.title":
    "Vítejte v nástroji pro online komunikaci se společností DHL Freight CZ",
  "welcome.text":
    "Společnost DHL Freight nyní nabízí pro registrované zákazníky možnost uzavřít smlouvu o přepravě věcí online, bez nutnosti kontaktovat zákaznický servis. Díky tomu je objednání přepravy vašich zásilek snazší a pohodlnější, než kdykoli předtím. Jednoduše se zaregistrujte a začněte posílat své zásilky prostřednictvím naší zcela digitální platformy.",
  "welcome.help":
    "V případě problému kontaktuje zákaznický servis na tel: +420 239 018 222 nebo na e-mailu: DHLFreight.CZ@dhl.com.",
  registration: "Registrace",
  "registration.new": "Nová registrace",
  "registration.old": "Rozpracovaná registrace",
  "registration.sent": "Odeslaná registrace",
  "registration.security.write": "Odeslat",
  "registration.security.wrong": "Byl zadán nekorektní přístupový kód.",
  "registration.security.password": "Přístupový kód",
  "registration.security.password.message": "Zadejte prosím přístupový kód",
  "registration.steps.form": "Údaje",
  "registration.steps.consents": "Souhlasy",
  "registration.steps.end": "Odeslání",
  "registration.description": "Registrace nového klienta",
  "registration.description.old": "Pokračovat v rozpracované registraci",
  "registration.description.sent": "Prohlédnout odeslanou registraci",
  "registration.detail.goBack": "Zpět",
  "registration.person.physical": "Fyzická osoba",
  "registration.person.legal": "Právnická osoba",
  "registration.companyIdOrNationalId": "IČO / RČ",
  "registration.companyId": "IČO",
  "registration.companyId.unknown":
    "Vážený zákazníku, automatická registrace je povolena pouze pro subjekty se sídlem v České Republice. Pro registraci prosím Zákaznický servis DHL Freight CZ na telefonním čísle 239 018 222 nebo napište email na DHLFreight.CZ@dhl.com.",
  "registration.representedBy": "Zastoupený",
  "registration.representedBy.empty":
    "Vyplňte prosím jméno a přijmení zastupující osoby.",
  "registration.municipal": "U",
  "registration.municipal.placeholder": "Magistrát města Ostrava",
  "registration.registeredAt.legal": "Zapsaný v Obchodním rejstříku",
  "registration.registeredAt.physical": "Zapsaný v Živnostenském rejstříku",
  "registration.registeredAt.empty": "Vyplňte prosím.",
  "registration.registeredAt.type": "Zapsaný v",
  "registration.registeredAt.type.commercialRegister": "Obchodním rejstříku",
  "registration.registeredAt.type.tradeRegister": "Živnostenském rejstříku",
  "registration.registeredAt.municipalCourt": "Městský soud",
  "registration.registeredAt.regionalCourt": "Krajský soud",
  "registration.registeredAt.section": "oddíl",
  "registration.registeredAt.liner": "vložka",
  "registration.bank.national": "český formát č.ú.",
  "registration.bank.international": "mezinárodní č.ú. - IBAN",
  "registration.bank.accountPrefix": "Předčíslí",
  "registration.bank.accountPrefix.invalid": "Předčíslí není validní",
  "registration.bank.account": "Číslo účtu",
  "registration.bank.account.empty": "Číslo účtu je povinné",
  "registration.bank.account.invalid": "Číslo účtu není validní",
  "registration.bank.code": "Kód banky",
  "registration.bank.code.empty": "Vyberte prosím kód banky",
  "registration.bank.code.loadError": "Při načítání bank nastala chyba",
  "registration.bank.iban": "IBAN",
  "registration.bank.iban.empty": "IBAN je povinný",
  "registration.bank.iban.invalid": "IBAN není validní",
  "registration.address": "Sídlo příkazce",
  "registration.address.home": "Trvalé bydliště",
  "registration.bank": "Bankovní spojení",
  "registration.address.invoice": "Fakturační adresa",
  "registration.address.pickup": "Svozová adresa",
  "registration.contacts": "Kontakty",
  "registration.contacts.principal": "Příkazce",
  "registration.contacts.principal.contact": "Jméno a příjmení",
  "registration.contacts.principal.email": "Email",
  "registration.contacts.principal.phone": "Telefon",
  "registration.contacts.email.invoice": "Email pro elektronickou fakturaci",
  "registration.contacts.email.business": "Email pro obchodní sdělení",
  "registration.contacts.contact.business": "Kontakt pro obchodní sdělení",
  "registration.contacts.phone.business": "Telefon pro obchodní sdělení",
  "registration.contacts.email.tracking": "Email pro tracking zásilek",
  "registration.products": "Produkty",
  "registration.products.ecdb2b": "DHL Freight EuroConnect Domestic",
  "registration.products.ecdb2b.info": "Firemní paleta / LTL přepravy",
  "registration.products.ecdb2b.text":
    "Vnitrostátní paletová přeprava kusových zásilek nabízí vynikající kvalitu, vysokou spolehlivost a nákladově efektivní doručení door-to-door.",
  "registration.products.ecdb2b.item.0": "Přepravy až do 800 kg / 3000 kg",
  "registration.products.ecdb2b.item.1":
    "Maximální hmotnost jedné zásilky: 3000 kg",
  "registration.products.ecdb2b.item.2":
    "Maximální hmotnost jedné položky: 800 kg",
  "registration.products.ecdb2b.item.3":
    "Maximální rozměry jedné položky: 400 cm (D) x 220 cm (Š) x 220 cm (V)",
  "registration.products.ecdb2b.item.4":
    "Automatické pojištění zásilky v ceně přepravného do hodnoty 500 000 Kč",
  "registration.products.ecdb2b.item.5":
    "Online sledování zásilky s upozorněním na události a s podrobnostmi o doručení",
  "registration.products.ecdb2b.item.6":
    "Jednoduchý objednací proces pomocí online nástrojů",
  "registration.products.ecdb2b.item.7": "Snadné vyzvednutí a doručení",
  "registration.products.ecdb2c": "DHL Freight Home Delivery Domestic",
  "registration.products.ecdb2c.info": "Soukromá paleta / LTL přepravy",
  "registration.products.ecdb2c.text":
    "Vnitrostátní paletová přeprava kusových zásilek nabízí vynikající kvalitu, vysokou spolehlivost a nákladově efektivní doručení door-to-door.",
  "registration.products.ecdb2c.item.0": "Přepravy až do 800 kg / 3000 kg",
  "registration.products.ecdb2c.item.1":
    "Maximální hmotnost jedné zásilky: 3000 kg",
  "registration.products.ecdb2c.item.2":
    "Maximální hmotnost jedné položky: 800 kg",
  "registration.products.ecdb2c.item.3":
    "Maximální rozměry jedné položky: 400 cm (D) x 220 cm (Š) x 220 cm (V)",
  "registration.products.ecdb2c.item.4":
    "Automatické pojištění zásilky v ceně přepravného do hodnoty 500 000 Kč",
  "registration.products.ecdb2c.item.5":
    "Online sledování zásilky s upozorněním na události a s podrobnostmi o doručení",
  "registration.products.ecdb2c.item.6":
    "Jednoduchý objednací proces pomocí online nástrojů",
  "registration.products.ecdb2c.item.7": "Snadné vyzvednutí a doručení",
  "registration.products.eci": "DHL Freight EuroConnect International",
  "registration.products.eci.info":
    "Spolehlivé a nákladově efektivní LTL přepravy",
  "registration.products.eci.text":
    "Náš síťový produkt Less-than-Truck-Load (LTL) pro paletizované a nepaletizované sběrné zásilky nabízí vynikající kvalitu, vysoce spolehlivá, nákladově efektivní door-to-door spojení po celé Evropě.",
  "registration.products.eci.item.0": "Zásilky do 2500 kg",
  "registration.products.eci.item.1":
    "Maximální hmotnost jedné položky: 1500 kg",
  "registration.products.eci.item.2":
    "Maximální rozměry jedné položky: 240 cm (D) x 220 cm (Š) x 220 cm (V) V ostatních případech kontaktujte prosím náš Zákaznický servis.",
  "registration.products.eci.item.3": "Odpovědnost podle CMR",
  "registration.products.eci.item.4":
    "Definované dodací doby na základě místa nakládky/vykládky",
  "registration.products.eci.item.5":
    "Denní přeprava spojující velká evropská obchodní centra",
  "registration.products.eci.item.6":
    "Online sledování zásilky s upozorněním na události a podrobnostmi o doručení",
  "registration.products.eci.item.7":
    "Jednoduchý objednací proces pomocí online nástrojů",
  "registration.products.eci.item.8": "Snadné vyzvednutí a doručení",
  "registration.products.eri": "DHL Freight Eurapid",
  "registration.products.eri.info":
    "LTL přepravy s možností definice dne nakládky a doručení",
  "registration.products.eri.text":
    "Naše celoevropské prioritní služby door-to-door s definovanými dny pro paletizované a nepaletizované sběrné zásilky, včetně kvalitního zákaznického servisu.",
  "registration.products.eri.item.0": "Zásilky do 2500 kg",
  "registration.products.eri.item.1":
    "Maximální hmotnost jedné položky: 1000 kg",
  "registration.products.eri.item.2":
    "Maximální rozměry jedné položky: 240 cm (D) x 120 cm (Š) x 220 cm (V)",
  "registration.products.eri.item.3": "Kvalitní zákaznický servis",
  "registration.products.eri.item.4":
    "Přislíbená data denního odjezdu / plánovaného příjezdu",
  "registration.products.eri.item.5":
    "Denní služba vyzvedávání / přednostní vyřízení",
  "registration.products.eri.item.6": "Na určitých PSČ vyzvednutí tentýž den",
  "registration.products.eri.item.7":
    "Proaktivní oznamování a online sledování zásilky",
  "registration.products.eri.item.8":
    "Informace o doručení (IOD) tentýž den a elektronický doklad o doručení (ePOD) do 24 hodin",
  "registration.products.warn": "Musíte vybrat alespoň jeden produkt!",
  "registration.address.invoice.same": "stejná jako sídelní",
  "address.name": "Název",
  "address.name.empty": "Zadejte prosím název!",
  "address.street": "Ulice",
  "address.street.empty": "Zadejte prosím název ulice!",
  "address.streetNumber": "Číslo popisné",
  "address.streetNumber.empty": "Zadejte prosím číslo popisné!",
  "address.city": "Město",
  "address.city.empty": "Zadejte prosím město!",
  "address.zipCode": "PSČ",
  "address.zipCode.empty": "Zadejte prosím PSČ!",
  "address.contactPerson": "Kontaktní osoba",
  "address.contactPerson.empty": "Zadejte prosím kontaktní osobu!",
  "address.contactPerson.firstName": "Jméno",
  "address.contactPerson.firstName.empty": "Zadejte prosím jméno!",
  "address.contactPerson.lastName": "Příjmení",
  "address.contactPerson.lastName.empty": "Zadejte prosím příjmení!",
  "address.contactPhone": "Telefon",
  "address.contactPhone.empty": "Zadejte prosím telefonní kontakt!",
  "address.preselection.loadError": "Při načítání předvoleb nastala chyba!",
  "address.contactEmail": "Email",
  "address.contactEmail.empty": "Zadejte prosím emailový kontakt!",
  "address.validation.zipCode.five": "Zadejte PSČ v pětimístném formátu!",
  "address.validation.zipCode.fiveCountry":
    "Zadejte PSČ v pětimístném formátu s prefixem kódu státu a pomlčkou (XX-)!",
  "address.validation.zipCode.four": "Zadejte PSČ v čtyřmístném formátu!",
  "address.validation.zipCode.fourCountry":
    "Zadejte PSČ v čtyřmístném formátu s prefixem kódu státu a pomlčkou (XX-)!",
  "address.validation.zipCode.poland":
    "Zadejte PSČ ve správném formátu (XX-XXX)!",
  "address.validation.zipCode.gbAndDe": "Zadejte PSČ ve správném formátu!",
  "address.validation.zipCode.alphanumeric": "PSČ musí být alfanumerické!",
  "address.validation.zipCode.others":
    "Zadejte PSČ v korektním formátu pro vybranou zemi!",
  "address.validation.phone.eight": "Zadejte telefonní číslo o délce 8!",
  "address.validation.phone.nineTen":
    "Zadejte telefonní číslo o délce 9 nebo 10!",
  "address.validation.phone.nine":
    "Zadejte telefonní číslo v devítimístném formátu!",
  "address.validation.phone.czech": "Zadejte validní české telefonní číslo!",
  "address.validation.phone.ten": "Zadejte telefonní číslo o délce 10!",
  "address.validation.phone.eleven":
    "Zadejte telefonní číslo o délce 10 nebo 11!",
  "address.validation.phone.tenMore":
    "Zadejte telefonní číslo o délce 10, 11, 12, 13, 14!",
  "address.validation.phone.others":
    "Zadejte telefonní číslo v korektním formátu pro vybranou zemi!",
  "registration.furtherInformation": "Další informace",
  "registration.maturity": "Splatnost faktury",
  "registration.maturity.weekly": "Týdenní",
  "registration.maturity.monthly": "Měsíční",
  "registration.placeOfSign": "Místo podpisu",
  "registration.placeOfSign.place": "sídlo příkazce",
  "registration.placeOfSign.home": "trvalé bydliště",
  "registration.placeOfSign.different": "jiné",
  "registration.terms.here": "aktuální obchodní podmínky pro tisk",
  "registration.terms":
    "Potvrzuji, že jsem přečetl obchodní podmínky a plně s nimi souhlasím.\n\nZároveň tímto souhlasím, že svou registrací do aplikace pro zákazníky a přijetím těchto obchodních podmínek jsou plně nahrazena veškerá dřívější ujednání, dohody či smlouvy uzavřené mezi zákazníkem a společností DHL, týkající se obdobného či stejného předmětu plnění (zejména služba přepravy), jako je uveden v této aplikaci pro zákazníky.",
  "registration.terms.mustHave": "Musíte souhlasit s obchodními podmínkami.",
  "registration.personalData": "souhlasím se zpracováním osobních údajů",
  "registration.personalData.mustHave":
    "Musíte souhlasit se zpracováním osobních údajů.",
  "registration.summary.title":
    "Registrace je skoro u konce, nyní potvrďte odeslání registrace do DHL kliknutím na tlačítko níže a očekávejte email s dalšími informacemi.",
  "registration.back": "zpět",
  "registration.continue": "pokračovat",
  "registration.sms.label": "Telefon pro potvrzení registrace",
  "registration.sms.message": "Zadejte prosím validní mobilní telefonní číslo!",
  "registration.sms.getCode": "Zaslat kód",
  "registration.sms.getCode.another": "Znovu zaslat kód",
  "registration.sms.code": "Potvrzovací kód z SMS",
  "registration.sms.success": "Kód byl úspěšně odeslán na Váš telefon.",
  "registration.sms.error":
    "Došlo k překročení limitu odeslaných SMS, zkuste to prosím později.",
  "registration.sms.error.extended":
    "Vážený zákazníku, překročil jste limit v zadání ověřujících SMS. Pro dokončení registrace prosím kontaktujte Zákaznický servis DHL Freight CZ na telefonním čísle 239 018 222 nebo napište email na DHLFreight.CZ@dhl.com.",
  "registration.sms.error.smsError":
    "Vážený zákazníku, momentálně není možné odesílat potvrzovací sms. V případě přetrvání tohoto problému kontaktujte Zákaznický servis DHL Freight CZ na telefonním čísle 239 018 222 nebo napište email na DHLFreight.CZ@dhl.com.",
  "registration.sms.phone.error": "Zadejte validní české telefonní číslo.",
  "registration.submit": "odeslat registraci",
  "registration.submit.title": "odešle registraci do DHL",
  "registration.submit.sms":
    "pro odeslání registrace je nutné potvrdit telefon",
  "registration.submit.result": "Registrace byla úspěšné zaevidována v DHL.",
  "registration.submit.result.error": "Při odesílání registrace nastala chyba.",
  "registration.validate": "validovat formulář",
  "registration.validate.title": "provede kontrolu dat ve formuláři",
  "registration.valid": "Formulář je validní a připraven k odeslání!",
  "registration.invalid": "Formulář není validní!",
  "registration.save": "uložit data",
  "registration.save.title": "uloží formulář pro pozdější vyplnění",
  "registration.save.result": "Registrace byla úspěšné uložena.",
  "registration.save.result.error": "Při ukládání registrace nastala chyba.",
  "registration.save.result.sms": "Nesprávný potvrzovací SMS kód.",
  "registration.drop": "smazat registraci",
  "registration.drop.title": "smaže dříve uloženou registraci",
  "registration.sent.info":
    "Registrace byla již odeslána do DHL, tudíž ji není možné editovat.",
  "registration.sent.insolvency":
    "Pro dokončení registrace prosím Zákaznický servis DHL Freight CZ na telefonním čísle 239 018 222 nebo napište email na DHLFreight.CZ@dhl.com.",
};

export default data;
